import { Component, OnInit } from '@angular/core';
import { AuthService, DictionaryService, ProfileService, SettingsService, SocketService } from '@app/services';
import { StoreKey } from './shared';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLoggedIn: boolean = false;
  isUserManualPage: boolean = false;
  loading: boolean = true;

  constructor(
    private authService: AuthService,
    private socketService: SocketService,
    private router: Router,
    private profileService: ProfileService,
    private dictionary: DictionaryService,
    private settingsService: SettingsService,
  ) {}

  ngOnInit() {
    combineLatest([this.authService.loggedStatus$, this.router.events.pipe(filter((event) => event instanceof NavigationEnd))]).subscribe(
      async ([logged, urlEvent]: [boolean, NavigationEnd]) => {
        if (urlEvent.url.includes('detached-login') || urlEvent.url.includes('sso-detached-logged')) {
          this.loading = false;
          return;
        }

        this.isLoggedIn = logged;
        this.isUserManualPage = urlEvent.url.includes('userManuals');
        if (logged) {
          // È loggato. Faccio la read del profilo per salvarla nel service, mi connetto al socket e lo porto nella lista licenze.
          const userId = localStorage.getItem(StoreKey.CUSTOMERID);
          const profile = await this.profileService.read();
          const languages = await this.dictionary.getLanguages();
          const userLanguage = languages.get(profile.settings.languageId);
          this.settingsService.loadLanguage(userLanguage);
          this.socketService.init(userId!);

          if (!this.isUserManualPage) {
            await this.router.navigate(['/licenses']);
          }
        } else {
          this.socketService.disconnect();
        }
        this.loading = false;
      },
    );
  }
}
